import ServiceBase from './serviceBase';
import { LibraryBaseService, LibraryComment } from './types/LibraryBase';
import { MiciCaseContext, MiciCaseList, MiciCaseMiciCause, MiciFilter } from './types/MiciCases';

class MiciCasesService extends ServiceBase implements LibraryBaseService {
  exportExcel = async (filter: MiciFilter): Promise<boolean> => {
    await this.download('micicases/excel', filter);
    return true;
  };

  getMiciCases = async (filter: MiciFilter): Promise<MiciCaseList> =>
    this.post<MiciCaseList>('micicases/search', filter);

  getMiciCaseContext = async (miciCaseNumber: string): Promise<MiciCaseContext> =>
    this.get<MiciCaseContext>(`micicases/${miciCaseNumber}/context`);

  saveDocuments = async (id: number, formData: FormData): Promise<number> => {
    const result = await this.post<number>(`micicases/${id}/documents`, formData);
    return result;
  };

  saveDocumentComment = async (comment: LibraryComment): Promise<void> => {
    await this.post<void>(`micicases/${comment.modelId}/document_comment`, comment);
  };

  saveCauses = async (miciCaseId: number, payload: MiciCaseMiciCause[]): Promise<boolean> => {
    const result = await this.put<boolean>(`micicases/${miciCaseId}/causes`, payload);
    return result;
  };

  downloadAttachment = async (miciCaseId: number, docId: number): Promise<boolean> => {
    await this.download(`micicases/${miciCaseId}/attachment/${docId}`);
    return true;
  };
}

const miciCasesService = new MiciCasesService();

export default miciCasesService;
